/**
 * views/index.js
 */
export {default as ErrorView} from './error/ErrorView';
export {default as PageLayout} from './layout/PageLayout';
export {default as BasePageView, mapStateToProps, mapDispatchToProps} from './basePage/BasePageView';
export {default as AssetsView} from './assets/AssetsView';
export {default as NewContentView} from './newContent/NewContentView';
export {default as OnSaleView} from './onSale/OnSaleView';
export {default as EventSaleView} from './eventSale/EventSaleView';
export {default as HomePageView} from './homePage/HomePageView';
export {default as CategoryView} from './category/CategoryView';
export {default as FeaturedView} from './featured/FeaturedView';
export {default as FreeView} from './free/FreeView';
export {default as AssetDetailView} from './assetDetail/AssetDetailView';
export {default as VaultView} from './vault/VaultView';
export {default as SellerAssetsView} from './sellerAssets/SellerAssetsView';